import React from 'react';
import { Navigate } from 'react-router-dom';
import Signin from '../pages/signin/Signin';
import AuthLayout from '../layouts/AuthLayout';
import ForgotPassword from '../pages/forgot-password/ForgotPassword';

export default [
  {
    path: '',
    element: (
      <AuthLayout>
        <Signin />
      </AuthLayout>
    )
  },
  {
    path: '/forgot-password',
    element: (
      <AuthLayout>
        <ForgotPassword />
      </AuthLayout>
    )
  },
  {
    path: '*',
    element: <Navigate to="/" />
  }
];
